import React, { useContext, useState } from 'react';
import { AuthContext } from '../AuthContext';
import {
    Container,
    Button,
    OverlayTrigger,
    Tooltip as BootstrapTooltip,
    Form,
    Alert,
    Row,
    Col,
    Card,
    Spinner
} from 'react-bootstrap';

function ServiceCenterSelect() {
    const { selectServiceCenter, serviceCenters, logoutUser, loading } = useContext(AuthContext);
    const [error, setError] = useState(null);
    const [selectedId, setSelectedId] = useState("");

    const handleSelectChange = (event) => {
        const selectedId = event.target.value;
        setSelectedId(selectedId);
        setError(null);
        
        if (selectedId) {
            const selectedCenter = serviceCenters.find(center => String(center.id) === selectedId);
            if (selectedCenter) {
                selectServiceCenter(selectedCenter);
            } else {
                setError('Выбранный сервисный центр не найден.');
            }
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{
            background: '#303238'
        }}>
            <Container>
                <Row className="justify-content-center">
                    <Col xs={11} sm={8} md={6} lg={5} xl={4}>
                        <Card className="shadow-lg border-0" style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '16px',
                            border: '1px solid rgba(255, 255, 255, 0.2)'
                        }}>
                            <div className="text-center py-4 px-3">
                                <div style={{
                                    width: '60px',
                                    height: '60px',
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 1rem'
                                }}>
                                    <i className="fas fa-building" style={{ fontSize: '1.5rem', color: 'white' }}></i>
                                </div>
                                <h4 className="text-white mb-1 fw-bold">Выбор склада</h4>
                                <p className="text-white-50 mb-0 small">Выберите сервисный центр</p>
                            </div>
                            
                            <Card.Body className="px-4 pb-4 pt-0">
                                {error && (
                                    <Alert variant="danger" className="mb-3 small" style={{
                                        borderRadius: '8px',
                                        border: 'none',
                                        background: 'rgba(220, 53, 69, 0.2)',
                                        color: '#f8d7da',
                                        border: '1px solid rgba(220, 53, 69, 0.3)'
                                    }}>
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        {error}
                                    </Alert>
                                )}

                                <Form>
                                    <Form.Group controlId="serviceCenterSelect" className="mb-4">
                                        <Form.Label className="text-white fw-semibold small">
                                            <i className="fas fa-warehouse me-2"></i>
                                            Доступные склады
                                        </Form.Label>
                                        <Form.Select 
                                            onChange={handleSelectChange} 
                                            value={selectedId}
                                            disabled={loading}
                                            style={{ 
                                                borderRadius: '8px',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                background: 'rgba(255, 255, 255, 0.1)',
                                                color: 'white',
                                                padding: '0.75rem'
                                            }}
                                        >
                                            <option value="" disabled style={{ background: '#495057', color: 'white' }}>
                                                -- Выберите сервисный центр --
                                            </option>
                                            {serviceCenters.map((center, index) => (
                                                center.id ? (
                                                    <option key={center.id} value={String(center.id)} style={{ background: '#495057', color: 'white' }}>
                                                        {center.name} {center.address ? `- ${center.address}` : ''}
                                                    </option>
                                                ) : (
                                                    <option key={index} value="" disabled style={{ background: '#495057', color: '#adb5bd' }}>
                                                        {center.name} {center.address ? `- ${center.address}` : ''} (Недоступен)
                                                    </option>
                                                )
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Form>

                                {serviceCenters.length === 0 && (
                                    <div className="text-center mt-3">
                                        <p className="text-white-50 small">
                                            <i className="fas fa-info-circle me-2"></i>
                                            Нет доступных сервисных центров
                                        </p>
                                    </div>
                                )}

                                {loading && (
                                    <div className="text-center mt-3">
                                        <Spinner animation="border" variant="light" style={{ width: '2rem', height: '2rem' }} />
                                        <p className="text-white-50 mt-2 small">Подключение...</p>
                                    </div>
                                )}

                                <div className="text-center mt-3">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<BootstrapTooltip>Выйти из системы</BootstrapTooltip>}
                                    >
                                        <Button 
                                            variant="outline-light" 
                                            onClick={logoutUser} 
                                            disabled={loading}
                                            size="sm"
                                            style={{ 
                                                borderRadius: '8px',
                                                border: '1px solid rgba(255, 255, 255, 0.3)'
                                            }}
                                        >
                                            <i className="fas fa-sign-out-alt me-2"></i>
                                            Выйти
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            </Card.Body>
                        </Card>
                        
                        <div className="text-center mt-3">
                            <small className="text-white-50">
                                <i className="fas fa-shield-alt me-1"></i>
                                Система управления складом
                            </small>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ServiceCenterSelect;